import { PublicKey } from "@solana/web3.js"

export const MERCHANT_PKEY = new PublicKey('8xWF7fUFMVCYct4cqD9qxpSifpLQPhXFeW9JAoajPcNv')
export const USDC_MINT = new PublicKey('EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v');
export const SERVER_URL = "https://api.nftsplash.xyz";
export const LANDING_PAGE_URL = "https://nftsplash.xyz";